export default __webpack_public_path__ + "static/media/weight_male@3x.d60d8738.png";